import { Author } from '@natu/ui/Author';
import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';

import { StoryblokRichtext, type StoryblokRichTextData } from '../../../../richtext';
import {
  type SBProps,
  sbEditable,
  type StoryblokAsset,
  getAssetFromStoryblok,
} from '../../../../utils';

interface SBTestimonialProps {
  colorVariant?: 'default' | 'white';
  text?: StoryblokRichTextData;
  avatar?: StoryblokAsset;
  name?: string;
  role?: string;
}

export const SBTestimonial = ({ blok }: SBProps<SBTestimonialProps>) => {
  const { colorVariant, text, avatar, name, role } = blok;

  const image = getAssetFromStoryblok(avatar);

  return (
    <div className="lg:mt-4" {...sbEditable(blok)}>
      <DynamicDecorator
        decorator="circle"
        className="text-naturaily-butterscotch relative left-10 hidden h-6 w-6 lg:block"
      />
      <DynamicDecorator
        decorator="quadrant"
        className="text-primary-500 hidden rotate-[-90deg] lg:block"
      />
      <StoryblokRichtext className="text-xl md:text-2xl lg:mt-4" data={text} />
      <Author
        className="mt-8 lg:mb-1.5"
        image={image}
        name={name}
        role={role}
        variant={colorVariant === 'white' ? 'white' : 'testimonial'}
      />
      <DynamicDecorator
        decorator="quadrant"
        className="text-naturaily-airborne relative hidden lg:left-[85%] lg:block"
      />
    </div>
  );
};
